import type { FaireProductEntity } from "../../entity_types/product";

export const p_khwz8qa5ap: FaireProductEntity = {
  token: "p_khwz8qa5ap",
  type: "product",
  name: "12\" x 12\" x 12\" Shipping Boxes - Bundle of 25",
  brandToken: "b_ajaj2rm3ar",
  brandName: "Store Supply Warehouse",
  imageUrl: "https://cdn.faire.com/fastly/0034e386ca440b5becf9f51f56015c5e4a06c3b813f5b5e8f68cbdefc333cdd2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b6d4d48921535584aabda42674a74eb9a17fb66952b6316f11bb17895f05f657.jpeg",
    "https://cdn.faire.com/fastly/1d9982fa5d6b444db546a383bae7ab8f6029c8820bb35158d93e7ef68dbd8682.jpeg"
  ],
  priceDollars: 30,
  description: "Cube-shaped 12\" x 12\" x 12\" corrugated shipping boxes with plenty of room for a variety of products and supplies.\n\n- Size: 12\" W x 12\" L x 12\" H\n- Material: corrugated\n- Ships and stores flat; assemble and seal when needed\n- Quantity: 25 boxes per bundle\n\nA practical choice for everyday packing, shipping and storage in stores, stockrooms and fulfillment areas.",
  tags: [],
  msrpDollars: 45,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:08.138Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
